import { useEffect, useState } from 'react'

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean>(true)

  useEffect(() => {
    const checkMobile = () => {
      // 디바이스가 터치 기반인지 확인 (coarse = 손가락 같은 불정밀 입력)
      const match = window.matchMedia('(pointer: coarse)').matches
      // touch event가 있는지(모바일인지) 확인
      const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
      // 화면 사이즈가 작은지 확인
      const smallScreen = window.innerWidth <= 500

      setIsMobile(match || touch || smallScreen)
    }

    checkMobile()

    window.addEventListener('resize', checkMobile)

    return () => {
      window.removeEventListener('resize', checkMobile)
    }
  }, [])

  return isMobile
}
